import React, { useEffect, useState } from "react";
import "./OurJourney.css";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

import banner from "../Images/about-banner.jpeg";
import brNaidu from "../Images/br-naidu.webp";
import launchEvent from "../Images/launch-event.webp";

import photo1 from "../Images/journey-photo1.webp";
import photo2 from "../Images/journey-photo2.webp";

const OurJourney = () => {

      const [bannerImage, setBannerImage] = useState(""); // Store banner image URL
  
    useEffect(() => {
      // Fetch banner data from API
      fetch("https://api.garudasena.org/api/banners")
        .then((response) => response.json())
        .then((data) => {
          // Find the banner for the "About Us" section
          const aboutUsBanner = data.find((banner) => banner.section === "About Us");
          if (aboutUsBanner) {
            setBannerImage(aboutUsBanner.image); // Set the banner image URL
          }
        })
        .catch((error) => console.error("Error fetching banner data:", error));
    }, []);
    
    
  return (
    <>
      <Navbar />

      <div className="journey-page">
        {/* 🏞️ Banner */}
        <section className="journey-banner">
          <img src={bannerImage} alt="Our Journey" className="banner-image" />
          <div className="banner-overlay">
            <h1>Our Journey</h1>
            <p>Faith, Service & the Path of Devotion</p>
          </div>
        </section>

        {/* 🌿 Section 1: Honoring Shri B.R. Naidu */}
        <section className="journey-section reverse">
          <div className="journey-text">
            <h2>Honoring Shri B.R. Naidu</h2>
            <p>
              On behalf of Sri Ashtothara Shatha (108) Chukkala Charitable Trust,
              it is my immense honor as Chairman to extend heartfelt
              congratulations to Shri B.R. Naidu on his prestigious appointment
              as Chairman of Tirumala Tirupati Devasthanams (TTD). His unwavering
              dedication to the service of Lord Venkateswara and his steadfast
              devotion to both spiritual and social upliftment have been an
              inspiration to countless devotees.
            </p>
            <p>
              Shri B.R. Naidu exemplifies true leadership, serving with humility,
              integrity, and a lifelong commitment to the values that TTD
              upholds. This esteemed position is a reflection of Shri Naidu’s
              dedication and is further strengthened by the support of respected
              leaders, including Honorable Chief Minister Shri Nara Chandrababu
              Naidu, Deputy Chief Minister Shri Pawan Kalyan, and the Minister
              for IT & Panchayati Raj, Shri Nara Lokesh.
            </p>
            <p>
              May Lord Venkateswara bless him with wisdom, strength, and
              compassion to lead TTD to new spiritual heights.
            </p>
          </div>
          <div className="journey-image">
            <img src={brNaidu} alt="Shri B.R. Naidu" />
          </div>
        </section>

        {/* 🌿 Section 2: Launch Event */}
        <section className="journey-section">
        
          <div className="journey-text">
            <h2>Launch Event with Hon'ble CM Nara Chandrababu Naidu</h2>
            <p>
              During the program launch, Hon'ble Chief Minister Shri Nara
              Chandrababu Naidu shared that 1.30 lakh people would benefit from
              the initiative. Beneficiaries, aged 18 to 70, will be selected
              through a transparent lottery system, with 90% reserved for the
              economically weaker sections from SC, ST, and BC communities.
            </p>
            <p>
              He emphasized the importance of serving guests as forms of God and
              encouraged the involvement of the Endowments Department, TTD, and
              local temples in the implementation of this divine initiative.
            </p>
          </div>
            <div className="journey-image">
            <img src={launchEvent} alt="Launch Event with CM Nara Chandrababu Naidu" />
          </div>
        </section>

        {/* 🌿 Section 3: Official Meeting */}
        <section className="journey-section reverse">
          <div className="journey-text">
            <h2>Government Collaboration and Devotee Welfare</h2>
            <p>
              Principal Secretary (Endowments) J.S.V. Prasad, APSRTC Managing
              Director Malakondaiah, Endowments Commissioner Anuradha, Sri Durga
              Malleswara Swamyvarla Devasthanam Executive Officer A. Surya
              Kumari, MLC Buddha Venkanna and others were present at the
              discussion.
            </p>
            <p>
              The government plans to facilitate travel for devotees to five
              major temples, including Tirumala. Each of the 13 districts will
              select participants annually. The estimated cost of Rs. 100 crore
              per year includes Rs. 40 crore for travel (shared by TTD and the
              Endowments Department), with food and accommodation supported by
              temple facilities.
            </p>
          </div>
          <div className="journey-image">
            <img src={launchEvent} alt="Official Meeting" />
          </div>
        </section>

        {/* 🌿 Section 4: Photo Highlights */}
        <section className="journey-section gallery">
          <h2>Our Journey Highlights</h2>
          <div className="journey-gallery">
            <img src={photo1} alt="Event Highlight 1" />
            <img src={photo2} alt="Event Highlight 2" />
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default OurJourney;
